import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AccessProvider } from "./context/AccessContext";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import StickyTrialBar from "./components/StickyTrialBar";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import AfterSchool from "./pages/AfterSchool";
import Schedule from "./pages/Schedule";
import Pricing from "./pages/Pricing";
import Newsletter from "./pages/Newsletter";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";
import TrialBooking from "./pages/TrialBooking";
import Tryout from "./pages/Tryout";
import Espanol from "./pages/Espanol";
import Portugues from "./pages/Portugues";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AccessProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/after-school" element={<AfterSchool />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/trial" element={<TrialBooking />} />
              <Route path="/tryout" element={<Tryout />} />
              <Route path="/es" element={<Espanol />} />
              <Route path="/pt" element={<Portugues />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <StickyTrialBar />
          <Toaster />
        </BrowserRouter>
      </AccessProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
